import { usePersistStore } from "@hooks/usePersistStore"
import { useSnapshot } from "valtio"
import { useSyncCart } from "./useSyncCart"

type Items = { productId: number; variationId?: number; quantity: number }[]

type CartStore = {
  items: Items
  coupons: string[]
}

export function useCartController(
  id: string,
  opts?: {
    doNotSync?: boolean
    enabled?: boolean
  }
) {
  let store = usePersistStore<CartStore>(`cart_${id}`, 3600, (data) => ({
    items: [],
    coupons: [],
    ...data,
  }))

  const { items, coupons } = useSnapshot(store) as CartStore

  const syncedCart = useSyncCart({
    items: items,
    coupons: coupons,
    doNotSync: opts?.doNotSync || opts?.enabled === false,
    enabled: opts?.enabled !== false,
  })

  return {
    ...syncedCart,
    setItems(items: Items) {
      store.items = items
    },
  }
}

export function useCartOrderController(orderId: number) {
  const syncedCart = useSyncCart({
    doNotSync: true,
    orderId: orderId,
    coupons: [],
    items: [],
  })

  return {
    ...syncedCart,
    setItems(items: Items) {},
  }
}

export type CartController = ReturnType<typeof useCartController>
